import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CopyTextToClipboardModule } from '../copy-text-to-clipboard/copy-text-to-clipboard.module';
import { ImageOrientationModule } from 'common/image-orientation/image-orientation.module';
import { LinkyModule } from 'ngx-linky';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { AutoAnswersService } from './auto-answers/auto-answers.service';
import { ListPickerMessageComponent } from './list-picker/list-picker-message/list-picker-message.component';
import { TimePickerMessageComponent } from './time-picker/time-picker-message/time-picker-message.component';
import { ChatMessagesComponent } from './chat-messages.component';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { AccessibilityFontSizeSetterModule } from '../accessibility-font-size-setter/accessibility-font-size-setter.component.module';
import { AccessibilityFontSizeSetterService } from '../accessibility-font-size-setter/accessibility-font-size-setter.service';
import { AutoAnswersModule } from 'shared/components/chat-messages/auto-answers/auto-answers.module';
import { SmartAdvisorModule } from 'shared/components/smart-advisor/smart-advisor.module';
import { SmartAdvisorService } from 'shared/components/smart-advisor/smart-advisor.service';
import { VideoChatStatusBubbleComponent } from 'shared/components/chat-messages/video-chat-status-bubble/video-chat-status-bubble.component';
import { RemoteControlSessionStatusBubbleComponent } from './remote-control-session-status-bubble/remote-control-session-status-bubble.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CopyTextToClipboardModule,
    CustomPipesModule,
    ImageOrientationModule,
    LinkyModule,
    SvgIconModule,
    AccessibilityFontSizeSetterModule,
    AutoAnswersModule,
    SmartAdvisorModule
  ],
  declarations: [
    ChatMessagesComponent,
    ListPickerMessageComponent,
    TimePickerMessageComponent,
    VideoChatStatusBubbleComponent,
    RemoteControlSessionStatusBubbleComponent
  ],
  providers: [
    AutoAnswersService,
    AccessibilityFontSizeSetterService,
    SmartAdvisorService
  ],
  exports: [
    ChatMessagesComponent
  ]
})

export class ChatMessagesModule {}
